import React, { useEffect, useRef, useState } from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { getAllDetails, postAllData } from "../../service/ApiService";
import { GET_GLOBAL_DATA, UPDATE_SLOT_COUNT } from "../../config/ApiConstant";
import { validateGlobalSettingData } from "../../config/Validate";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import Loader from "../../components/Loader/Loader";

const GlobalSetting = () => {
  const toast = useRef<any>(null);

  // confirmation Dialog
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  // loading
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [pageLoad, setPageLoad] = useState<boolean>(false);

  // error obj
  const [errors, setErrors] = useState<any>({});

  // setting Data obj
  const [globalSettingData, setglobalSettingData] = useState<any>({});

  // min date from current date
  const minDate = moment().add(1, "days").toDate();

  // use effect to get globle setting data
  useEffect(() => {
    getGlobalData();
  }, []);

  // on change
  const onInputChange = (e: any, name: string) => {
    let val;
    val = e?.target?.value ?? e?.value;

    setglobalSettingData({ ...globalSettingData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  //   close booking model
  const closeConfirmationDialog = () => {
    setShowConfirmation(false);
  };

  // update globle data
  const confirmGlobleData = () => {
    const { errors, isError } = validateGlobalSettingData(globalSettingData);
    setErrors(errors);
    if (isError) return;

    setShowConfirmation(true);
  };

  // get globle data
  const getGlobalData = async () => {
    try {
      const response = await getAllDetails(GET_GLOBAL_DATA);
      const data = response;

      if (data) {
        setglobalSettingData(data);
        setPageLoad(true);
      } else {
        setglobalSettingData({});
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // submit form api call
  const submitGlobleSettingData = async () => {
    try {
      const { errors, isError } = validateGlobalSettingData(globalSettingData);
      setErrors(errors);
      if (isError) return;

      setIsLoading(true);

      const payload = {
        slot_count: globalSettingData?.slot_count_per_day,
        no_of_days_enable: globalSettingData?.no_of_days_enable,
        tax_filing_start_date: globalSettingData?.tax_filing_start_date ? moment(globalSettingData.tax_filing_start_date).format("YYYY-MM-DD") : null,
      };

      const response = await postAllData(UPDATE_SLOT_COUNT, payload);

      if (response) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response?.message,
        });
        getGlobalData();
        setShowConfirmation(false);
        setIsLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppBreadcrumb currentMenu="Global" pageName="Setting" pageTitle="Global Setting" goToPage={true} />
      <div className="grid crud-demo  ">
        <div className="col-12 ">
          <div className="">
            <Toast ref={toast} />

            <div className="grid mt-3">
              <div className="col-12  ">
                <div className="card ">
                  <h5 className="m-0">Global Settings</h5>
                  <div className="grid p-fluid formgrid mt-3">
                    {/* slot count */}
                    <div className="field col-12 md:col-3">
                      <label htmlFor="name">Number of Tax Filling Per Day *</label>
                      <div className="input-effect-div">
                        <InputText
                          value={globalSettingData?.slot_count_per_day || ""}
                          name="slot_count_per_day"
                          onChange={(e) => onInputChange(e, "slot_count_per_day")}
                          className={errors["slot_count_per_day"] && "p-invalid"}
                          keyfilter="pint"
                          maxLength={10}
                          placeholder="Enter Slot Count"
                        />
                        <span className="focus-bg"></span>
                      </div>
                      <small className="p-invalid-txt">{errors["slot_count_per_day"]}</small>
                    </div>

                    {/* Days to enable */}
                    <div className="field col-12 md:col-3">
                      <label htmlFor="name">Tax Processing & Filling Period (Days) *</label>
                      <div className="input-effect-div">
                        <InputText
                          value={globalSettingData?.no_of_days_enable || ""}
                          name="no_of_days_enable"
                          onChange={(e) => onInputChange(e, "no_of_days_enable")}
                          className={errors["no_of_days_enable"] && "p-invalid"}
                          keyfilter="pint"
                          maxLength={10}
                          placeholder="Enter no of days to enable"
                        />
                        <span className="focus-bg"></span>
                      </div>
                      <small className="p-invalid-txt">{errors["no_of_days_enable"]}</small>
                    </div>

                    {/* Tax Filling Start Date */}
                    <div className="field col-12 md:col-3">
                      <label htmlFor="date">Tax Filing Start Date *</label>
                      <div className="input-effect-div">
                        <Calendar
                          value={
                            globalSettingData.tax_filing_start_date ? moment(globalSettingData.tax_filing_start_date, "YYYY-MM-DD").toDate() : null
                          }
                          dateFormat="dd/mm/yy"
                          placeholder="Select Tax Filing Start Date"
                          onChange={(e) => onInputChange(e, "tax_filing_start_date")}
                          className={errors["tax_filing_start_date"] && "p-invalid"}
                          showIcon
                          minDate={minDate}
                        />
                        <span className="focus-bg"></span>
                      </div>
                      <small className="p-invalid-txt">{errors["tax_filing_start_date"]}</small>
                    </div>

                    <div className="card-footer flex flex-wrap gap-2 mt-4 md:gap-3 justify-content-end align-items-center">
                      <div className="button-group">
                        <Button className="common-primary-button" label="Update" icon="pi pi-check" onClick={confirmGlobleData} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* dialog to confirm global setting */}
            <Dialog
              header="Update"
              visible={showConfirmation}
              style={{ width: "450px" }}
              footer={
                <div className="booking-footer">
                  <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={closeConfirmationDialog} />
                  <Button
                    className="common-primary-button"
                    label="Submit"
                    icon="pi pi-check"
                    onClick={submitGlobleSettingData}
                    disabled={isLoading}
                    loading={isLoading}
                  />
                </div>
              }
              draggable={false}
              onHide={() => !isLoading && setShowConfirmation(false)}
              closable={!isLoading}
            >
              <div className="flex align-items-center justify-content-start">
                <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: "2rem" }} />

                <span className="delete-dialog-note">Note: Are you sure you want to update</span>
              </div>
            </Dialog>
          </div>
        </div>
      </div>
    </>
  );
};

export default GlobalSetting;
